var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dateTxt)?_c('div',[_vm._v("\n    "+_vm._s(_vm._f("formatDateTime")(_vm.dateTxt))+"\n")]):_c('div',{staticClass:"text-center"},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }